import React, { Component } from 'react';
import { Table } from 'reactstrap';
import { connect } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import ReportHead from './ReportHead';
import ReportBody from './ReportBody';

class ReportTable extends Component {
    render(){
        const { reportId, reportsLoading } = this.props;
        return (
            reportsLoading ? 
                <Skeleton count="15"/> : 
                <Table hover responsive bordered>
                    <thead>
                        <ReportHead reportId={reportId} />
                    </thead>
                    <tbody>
                        <ReportBody reportId={reportId} />
                    </tbody>
                </Table>
        );
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
    reportsLoading: state.reportStore.reportsLoading,
});

export default connect(mapStateToProps)(ReportTable);


// WEBPACK FOOTER //
// ./src/Components/App/Reports/TabularReport/ReportTable.js